import { ApolloClient } from '@apollo/client'
import { takeLatest } from 'redux-saga/effects'
import { actionTypes } from './index'
import createFetchSaga from '@utils/store/createFetchSaga'
import outboundReceiptsGetQuery from '@queries/outboundReceiptsGetQuery'
import fetchAsyncExport from '@utils/fetchAsyncExport'
import { sagaDebounce } from '@store/helpers'

const fetchList = async (client: ApolloClient<any>, action: Action): Promise<any> => {
  const outboundReceipts = await client
    .query({ query: outboundReceiptsGetQuery, variables: { ...action.payload, nested: true } })
    .then(({ data }) => ({ data: data?.outboundReceiptsGet }))

  return outboundReceipts
}

export default function* watch(): Generator {
  if (typeof window === 'undefined') return
  yield sagaDebounce(200, actionTypes.run, createFetchSaga(actionTypes.run, fetchList))
  yield takeLatest(actionTypes.export.run, createFetchSaga(actionTypes.export.run, fetchAsyncExport('outbound-receipt')))
}
